import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

export class HttpService {
    public async getRequest<TResponse, TParams = any>(
        url: string,
        params?: TParams,
        config?: AxiosRequestConfig
    ): Promise<TResponse> {
        const response: AxiosResponse<TResponse> = await axios.get(url, {
            ...config,
            params,
        });
        return response.data;
    }

    public async postRequest<TRequest, TResponse>(
        url: string,
        data: TRequest,
        config?: AxiosRequestConfig
    ): Promise<TResponse> {
        const response: AxiosResponse<TResponse> = await axios.post(url, data, config);
        return response.data;
    }

    public async putRequest<TRequest, TResponse>(
        url: string,
        data: TRequest,
        config?: AxiosRequestConfig
    ): Promise<TResponse> {
        const response: AxiosResponse<TResponse> = await axios.put(url, data, config);
        return response.data;
    }
}

export default new HttpService();
